import { get } from '../api';

type LicenseFilters = {
  onlyIds: string;
  idsAndMatches: string;
  pageSize: number;
};

export const FETCH_LICENSES = 'FETCH_LICENSES';

export default {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  fetchAll: (filters: LicenseFilters) => ({
    type: FETCH_LICENSES,
    async payload() {
      return get(`/api/licenses`, true, filters);
    },
  }),
};
